var ErrorHandling = {
    config: {
        noBasePage: "",
        maintenancePage: "",
    },
    init: function (options) {
        this.config = $.extend(this.config, options);
        $(document).ajaxError($.proxy(this.ajaxErrorHandling, this));
        window.onerror = $.proxy(this.jsErrorHandling, this);
    },
    ajaxErrorHandling: function (event, jqXHR, ajaxSettings, thrownError) {
        if (jqXHR.status == 501) {
            window.location.href = this.config.noBasePage;
        } else if (jqXHR.status == 520) {
            window.location.href = this.config.maintenancePage;
        } else if (jqXHR.status == 500) {
            var response;
            try {
                response = $.parseJSON(jqXHR.responseText);
            } catch (err) { };

            var body = ErrorHandling.messages.ajaxErrorBody(ajaxSettings.type, ajaxSettings.url)

            if (response && response.exception && response.message) {
                body += ErrorHandling.messages.ajaxErrorExceptionClass(response.exception) + ErrorHandling.messages.ajaxErrorExceptionMessage(response.message);
            } else if (jqXHR.responseText.indexOf("<html>") > -1) {
                body += ErrorHandling.messages.ajaxErrorExceptionMessage(jqXHR.responseText);
            }
            alertMsg({
                title: ErrorHandling.messages.ajaxErrorTitle,
                message: body
            });
        }
    },
    jsErrorHandling: function (description, page, line) {
        alertMsg({
            title: ErrorHandling.messages.jsErrorTitle,
            message: ErrorHandling.messages.jsErrorBody(description, page, line)
        });
    }
}